import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { rolPatch } from "../../store/rol/actions";
export var useRolPatch = function (trigger, body, id) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        responseRolPatch: state.Rol.responseRolPatch,
        errorRolPatch: state.Rol.errorGeneralCatalogPatch,
        loadingRolPatch: state.Rol.loadingGeneralCatalogPatch,
    }); }), responseRolPatch = _a.responseRolPatch, errorRolPatch = _a.errorRolPatch, loadingRolPatch = _a.loadingRolPatch;
    useEffect(function () {
        if (trigger) {
            dispatch(rolPatch({
                name: body.RolName,
                description: body.RolDescription,
                permissions: body.Permissions,
            }, body.id));
        }
    }, [trigger]);
    return {
        responseRolPatch: responseRolPatch,
        errorRolPatch: errorRolPatch,
        loadingRolPatch: loadingRolPatch,
    };
};
